import React from 'react';
import Row from '@amzn/meridian/row';
import Column from '@amzn/meridian/column';
import { CorePage, CorePageTitle } from '$/components';
import { RootUri, ProjectUri, ProjectDetailUri } from '$/features/routes';
import { CoreTabGroupSwitch, CoreTabRoute } from '@amzn/dots-core-ui';
import { useParams } from 'react-router-dom';
import Heading from '@amzn/meridian/heading';
import { BuildFilesList } from './components/BuildFilesList';

// Helper function to extract numeric ID from project name (e.g., "Project_1" -> 1)
const extractProjectId = (projectName: string): number => {
  const match = projectName.match(/Project_(\d+)/);
  return match ? parseInt(match[1], 10) : 0;
};

export const BuildFilesListPage = (): JSX.Element => {
  const { name, version } = useParams<{ name: string; version: string }>();
  const projectName = name;
  const buildVersion = version;
  const projectId = extractProjectId(projectName);

  return (
    <CorePage
      title={`${projectName} - ${buildVersion}`}
      breadcrumbs={[
        { title: 'Storage', href: RootUri },
        { title: 'Projects', href: ProjectUri },
        { title: `${projectName}`, href: ProjectDetailUri(projectId) },
      ]}
      header={
        <>
          <Row widths={['fill', 'fit']}>
            <Column>
              {projectName && <CorePageTitle title={projectName} />}
              {buildVersion && (
                <Heading level={3}>
                  Build Version:
                  {buildVersion}
                </Heading>
              )}
            </Column>
          </Row>
        </>
      }
    >
      <CoreTabGroupSwitch>
        <CoreTabRoute label="Files" path="files">
          <BuildFilesList
            projectName={projectName}
            buildVersion={buildVersion}
          />
        </CoreTabRoute>
        <CoreTabRoute label="Details" path="details">
          <Column spacingInset="400">
            <Row>
              <Heading level={3}>Build Details</Heading>
            </Row>
            <Row>
              <p>Additional build details would be displayed here.</p>
            </Row>
          </Column>
        </CoreTabRoute>
      </CoreTabGroupSwitch>
    </CorePage>
  );
};
